export var ContextGLClearMask;
(function (ContextGLClearMask) {
    ContextGLClearMask[ContextGLClearMask["COLOR"] = 1] = "COLOR";
    ContextGLClearMask[ContextGLClearMask["DEPTH"] = 2] = "DEPTH";
    ContextGLClearMask[ContextGLClearMask["STENCIL"] = 4] = "STENCIL";
    ContextGLClearMask[ContextGLClearMask["ALL"] = 7] = "ALL";
})(ContextGLClearMask || (ContextGLClearMask = {}));
